<script setup>
import { inject, computed, onMounted } from 'vue';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import ProductCard from '@/app/components/product-card/product-card.vue';
import { useProductsStore } from '@/app/stores/productsStore.js';

const productsStore = useProductsStore();

const config = inject('config');
const gaPush = inject('gaPush');

const prodLength = computed(() => config.products.length);

const carouselOptions = {
  mediaQuery: 'min',
  perPage: 1,
  gap: '2rem',
  padding: '10%',
  pagination: false,
  perMove: 1,
  speed: 200,
  breakpoints: {
    0: {
      destroy: prodLength.value <= 1,
      live: prodLength.value > 1,
      arrows: prodLength.value > 1,
      focus: 'center',
    },
    768: {
      focus: null,
      arrows: prodLength.value > 2,
      perPage: 2,
      perMove: 2,
      padding: 0,
    },
  },
  i18n: {
    prev: config.previousSlideLabel,
    next: config.nextSlideLabel,
    carousel: config.carouselRole,
    slide: config.slideRole,
  },
};

onMounted(() => {
  productsStore.setLocales();
});
</script>

<template>
  <div class="c-related-products">
    <Splide :has-track="false" :options="carouselOptions" :aria-label="config.relatedProductsTitle">
      <div class="c-related-products__top">
        <h2 class="c-related-products__heading">{{ config.relatedProductsTitle }}</h2>
        <div class="splide__arrows">
          <button class="c-related-projects__arrow splide__arrow splide__arrow--prev">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 40 40"
              width="40"
              height="40"
              focusable="false"
            >
              <path
                d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"
              ></path>
            </svg>
          </button>
          <button class="c-related-projects__arrow splide__arrow splide__arrow--next">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 40 40"
              width="40"
              height="40"
              focusable="false"
            >
              <path
                d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"
              ></path>
            </svg>
          </button>
        </div>
      </div>
      <div class="c-related-products__track">
        <SplideTrack>
          <template v-for="product in config.products" :key="product.id">
            <SplideSlide>
              <ProductCard
                :standalone="true"
                :product="product"
                :showTags="false"
                gaPrefix="prod_card_"
                :productTitleHeadingLevel="3"
                :productDetailsHeading="config.productSpecsTitle"
              /> </SplideSlide
          ></template>
        </SplideTrack>
      </div>
    </Splide>
  </div>
</template>

<style lang="css" scoped>
.splide__track {
  overflow: unset;
}

.splide__slide {
  transition: all 0.2s ease-out;
}

.splide__slide[aria-hidden='true'] {
  opacity: 40%;
}
@media (min-width: 768px) {
  .splide__slide[aria-hidden='true'] {
    opacity: 0;
  }
}

@media (min-width: 1200px) {
  .splide__slide[aria-hidden='true'] {
    opacity: 40%;
  }
}

.splide__track {
  overflow: unset;
}

.splide__slide {
  transition: all 0.2s ease-out;
}

@media (min-width: 768px) {
  .splide__slide:only-child {
    width: calc(50% - 1rem);
  }
}

.splide__slide[aria-hidden='true'] {
  opacity: 40%;
}

@media (min-width: 768px) {
  .splide__slide[aria-hidden='true'] {
    opacity: 0;
  }
}

@media (min-width: 1200px) {
  .splide__slide[aria-hidden='true'] {
    opacity: 40%;
  }
}

/* Arrow button styles */
.splide__arrows {
  display: flex;
  gap: 1rem;
}
</style>